module.exports = __webpack_public_path__ + "img/facillgpd-empresa.75ffcae5.png";